export default __webpack_public_path__ + "static/media/1.4e6e6845.png";